import { useState, useEffect } from 'react';

const MAX_RECENT_PRODUCTS = 8;

export const useRecentlyViewed = () => {
  const [recentProducts, setRecentProducts] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem('recentlyViewed');
    if (stored) {
      try {
        setRecentProducts(JSON.parse(stored));
      } catch (e) {
        localStorage.removeItem('recentlyViewed');
      }
    }
  }, []);

  const addToRecentlyViewed = (product) => {
    setRecentProducts(prev => {
      // Remove if already exists
      const filtered = prev.filter(p => p.id !== product.id);
      // Add to beginning
      const updated = [product, ...filtered].slice(0, MAX_RECENT_PRODUCTS);
      // Save to localStorage
      localStorage.setItem('recentlyViewed', JSON.stringify(updated));
      return updated;
    });
  };

  const clearRecentlyViewed = () => {
    setRecentProducts([]);
    localStorage.removeItem('recentlyViewed');
  };

  return { recentProducts, addToRecentlyViewed, clearRecentlyViewed };
};